// src/components/Button/Button.jsx
import React from "react";
//import "./Button.less";
import styles from "./Button.module.less";
import classNames from "classnames";

/**
 * Componente Button reutilizable
 * @param {Object} props - Propiedades del botón
 * @param {string} props.variant - Variante del botón: 'primary' | 'secondary'
 * @param {string} props.size - Tamaño: 'small' | 'medium' | 'large'
 * @param {boolean} props.disabled - Si está deshabilitado
 * @param {boolean} props.loading - Si está en estado de carga
 * @param {ReactNode} props.children - Contenido del botón
 * @param {string} props.className - Clases CSS adicionales
 * @param {Object} props.rest - Otras propiedades
 */
const Button = ({
  variant = "primary",
  size = "medium",
  disabled = false,
  loading = false,
  children,
  className,
  ...rest
}) => {
  const buttonClasses = classNames(
    styles.button,
    styles[variant],
    styles[size],
    {
      [styles.disabled]: disabled,
      [styles.loading]: loading,
    },
    className
  );

  return (
    <button className={buttonClasses} disabled={disabled || loading} {...rest}>
      {loading ? "Cargando..." : children}
    </button>
  );
};

export default Button;
